import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { canViewAdmin } from '../../lib/adminAccess';

/** Navigation is cosmetic; every admin route also reevaluates this access gate. */
export function AdminAccessGate({ user, children }: { user: { email: string } | null | undefined; children: ReactNode }) {
  return canViewAdmin(user) ? <>{children}</> : <Navigate to="/drivers" replace />;
}
